import { CartGroup, CartItem } from '../store'

export function groupCartItems(items: CartItem[]): CartGroup[] {
  const groupsMap = new Map<string, CartGroup>()

  items.forEach(item => {
    const groupKey = `${item.courtroom.id}-${item.recordingDate.toString()}`
    const group = groupsMap.get(groupKey)

    if (group) {
      group.items.push(item)
    } else {
      groupsMap.set(groupKey, {
        key: groupKey,
        courthouse: item.courthouse,
        courtroom: item.courtroom,
        recordingDate: item.recordingDate,
        items: [item],
      })
    }
  })

  const groups = Array.from(groupsMap.values()).sort((a, b) => a.recordingDate.compareTo(b.recordingDate))
  groups.forEach(group => {
    group.items.sort((a, b) => a.sessionTime.start.compareTo(b.sessionTime.start))
  })

  return groups
}
